<script setup lang="ts">
import { useLogout } from "@cms/features/Auth/Logout/useLogout";
import VIcon from "@verbleif/lib/src/components/Icon/VIcon.vue";
import Avatar from "@verbleif/shared/src/components/Avatar/Avatar.vue";
import { useAuthStore } from "@verbleif/shared/src/composables/AuthStore/useAuthStore";
import { useI18n } from "vue-i18n";
import NavbarLocaleChange from "./NavbarLocaleChange/NavbarLocaleChange.vue";
import NavbarSettingsItem from "./NavbarSettingsItem.vue";

const authStore = useAuthStore();
const { logout } = useLogout();
const { t } = useI18n();
const TRANSLATION_KEY = "navbar.dropdown";
</script>

<template>
  <VDropdown
    theme="verbleif-popper-bounded"
    placement="right"
    auto-size="min"
  >
    <template #popper>
      <div class="flex flex-col">
        <div class="flex items-center mx-4 mt-4 mb-3">
          <Avatar :name="authStore.user.value?.name" :avatar-url="authStore.user.value?.avatar?.contentUrl" class="mr-2" size="xs" />
          <div class="text-xs">
            {{ authStore.user.value?.name }}
          </div>
        </div>
        <div class="flex flex-col">
          <NavbarLocaleChange />
          <div v-close-popper.all @click="logout()">
            <NavbarSettingsItem variant="danger" icon="log-out" :text="t(`${TRANSLATION_KEY}.logout`)" />
          </div>
        </div>
      </div>
      <div class="flex w-full bg-gray-50 dark:bg-dark-800 text-gray-500 py-2 mt-4 px-4 text-xs">
        <div class="mr-10 font-bold uppercase">
          {{ t("navbar.download_apps") }}:
        </div>
        <div class="flex gap-3">
          <a class="cursor-pointer hover:text-primary-500 active:text-primary-700" href="https://verbleif.com/android" target="_blank" rel="noopener noreferrer">
            <VIcon name="brand-android" />
          </a>
          <a class="cursor-pointer hover:text-primary-500 active:text-primary-700" href="https://verbleif.com/ios" target="_blank" rel="noopener noreferrer">
            <VIcon name="brand-apple" />
          </a>
        </div>
      </div>
    </template>
    <div class="nav-item-small">
      <Avatar
        :name="authStore.user.value?.name"
        :avatar-url="authStore.user.value?.avatar?.contentUrl"
        size="sm"
        class="avatar-trigger"
      />
    </div>
  </VDropdown>
</template>

<style lang="scss" scoped>
.avatar-trigger {
  transition: transform 100ms ease-in-out;

  &:hover {
    transform: scale(1.05);
  }
}
</style>
